"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const parseQuestionAnswer_1 = __importDefault(require("./parseQuestionAnswer"));
const validateQuestionAnswer_1 = __importDefault(require("./validateQuestionAnswer"));
const isQuestionComplete = (question, answer) => (typeof (0, validateQuestionAnswer_1.default)(question, (0, parseQuestionAnswer_1.default)(question, answer)) === 'undefined');
exports.default = isQuestionComplete;
